import { assign } from 'lodash';

import { Point } from 'cdl';

// Simple retargetting without tracking

const SimpleTracker3D = function(event,docIsland) {
  this._event = event;
  this._docIsland = docIsland;
};
SimpleTracker3D.prototype.track = function({ view }) {

  const docIsland = this._docIsland,
        modelPoint = this._event.modelPoint, // Important, this._event is different from track(event) here
        modelIsland = view.modelIslandFor(docIsland),
        docPoint = view.modelToDoc(modelPoint,docIsland);

  return {
    modelPoint,
    modelIsland,
    docIsland,
    docPoint,
    modelPointRaw  : modelPoint,
    modelIslandRaw : modelIsland,
    docIslandRaw   : docIsland,
    docPointRaw    : docPoint,
  };
};

export function retargetEvent3D( event, docIsland ) {
  return event.retarget( event.eventDown, new SimpleTracker3D(event,docIsland) );
}


// Move3D helper to track the mouse starting from a given doc island
// and following it even if it goes out it or the model

export const Tracker3D = function( { view, event, viewPoint, modelPoint }, docIsland ) {

  const docPoint = view.modelToDoc(modelPoint,docIsland);
  const modelIsland = view.modelIslandFor(docIsland);

  assign( this, { view,

    event,
    eventDown: event,

    // Points following the original island
    // This is used for almost all tools
    modelPoint,
    modelIsland,
    docIsland,
    docPoint,

    // Tracking, always against the docIslandDown
    viewPointLast  : viewPoint,
    modelPointLast : modelPoint,

    // Points that jumps between islands, useful for move operations
    modelPointRaw  : modelPoint,
    modelIslandRaw : modelIsland,
    docIslandRaw   : docIsland,
    docPointRaw    : docPoint,

    // Raw tracking, front => sleeve => out (should use sleeve points)
    viewPointFirstRaw : viewPoint,
    viewPointLastRaw  : viewPoint,

    modelPointFirstRaw : modelPoint,
    modelPointLastRaw  : modelPoint,

    started        : false,
  });

  this.retargetedEventDown = this.retargetedEvent;
};

Tracker3D.prototype = {

  get retargetedEvent() {
    return this.event.retarget(this.retargetedEventDown,this);
  },

  track() {

    const { view, viewPoint, originalEvent } = this.event;
    const modelPoint = view.modelPoint(originalEvent);

    const { eventDown, docIsland, modelIsland } = this;

    if( modelPoint && ! modelPoint.isEqual(eventDown.modelPoint) ) {
      this.started = true;
    }

    if( ! this.started ) {
      return this.trackData();
    }

    let modelPointRaw = modelPoint;

    if( modelPoint && ! view.modelPointIsOut(modelPoint,modelIsland) ) {

      this.modelPoint = modelPoint;

      this.viewPointLast  = viewPoint;
      this.modelPointLast = modelPoint;
    }
    else {

      // We need to come up with a proper modelPoint to continue the movement
      this.modelPoint = interpolatingExtension( viewPoint, eventDown.viewPoint,  this.viewPointLast,
                                                           eventDown.modelPoint, this.modelPointLast );
    }

    this.docPoint = view.modelToDoc(this.modelPoint,this.docIsland);

    // Raw properties

    if( modelPointRaw && view.modelPointIsOut(modelPointRaw,this.modelIslandRaw) ) {

      const docIslandRaw = view.topDocIslandAtModel(modelPointRaw);
      if( docIslandRaw && docIslandRaw.page === docIsland.page ) {
        this.modelIslandRaw = view.modelIslandAt(modelPointRaw);
        this.docIslandRaw = docIslandRaw;

        this.viewPointFirstRaw  = viewPoint;
        this.modelPointFirstRaw = modelPointRaw;
      }
      else {
        // Trigger interpolation
        modelPointRaw = null;
      }
    }

    if( modelPointRaw ) {

      this.modelPointRaw = modelPointRaw;

      this.viewPointLastRaw  = viewPoint;
      this.modelPointLastRaw = modelPointRaw;
    }
    else {

      // We need to come up with a proper modelPointRaw to continue the movement
      this.modelPointRaw = interpolatingExtension( viewPoint, this.viewPointFirstRaw,  this.viewPointLastRaw,
                                                              this.modelPointFirstRaw,  this.modelPointLastRaw );
    }

    this.docPointRaw = view.modelToDoc(this.modelPointRaw,this.docIslandRaw);

    return this.trackData();
  },

  trackData() {
    return {
      modelIsland    : this.modelIsland,
      docIsland      : this.docIsland,
      docPoint       : this.docPoint,
      modelPointRaw  : this.modelPointRaw,
      modelIslandRaw : this.modelIslandRaw,
      docIslandRaw   : this.docIslandRaw,
      docPointRaw    : this.docPointRaw,
    };
  },

  move(event) {
    this.event = event;
    return this.retargetedEvent;
  }
};



// Move3D helper to track the mouse starting from a given doc island
// and following it even if it goes out it or the model

export const TextureTracker = function( { view, event, viewPoint, modelPoint }, docIsland ) {

  const docPoint = view.modelToDoc(modelPoint,docIsland);
  const modelIsland = view.modelIslandFor(docIsland);

  assign( this, { view,

    event,
    eventDown: event,

    // Points following the original island
    // This is used for almost all tools
    modelPoint,
    modelIsland,
    docIsland,
    docPoint,

    // Points that jumps between islands, useful for move operations
    modelPointRaw  : modelPoint,
    modelIslandRaw : modelIsland,
    docIslandRaw   : docIsland,
    docPointRaw    : docPoint,

    started: false,
  });

  this.retargetedEventDown = this.retargetedEvent;
};

TextureTracker.prototype = {

  get retargetedEvent() {
    return this.event.retarget(this.retargetedEventDown,this);
  },

  track() {

    const { view, originalEvent } = this.event;

    const modelPoint = view.modelPoint(originalEvent);

    const { eventDown, docIsland } = this;

    if( modelPoint && ! modelPoint.isEqual(eventDown.modelPoint) ) {
      this.started = true;
    }

    if( ! this.started ) {
      return this.trackData();
    }

    this.modelPoint = modelPoint;
    this.docPoint = view.modelToDoc(modelPoint,docIsland);

    // Raw properties


    if( view.modelPointIsOut(modelPoint,this.modelIslandRaw) ) {

      const docIslandRaw = view.topDocIslandAtModel(modelPoint);
      if( docIslandRaw && docIslandRaw.page === docIsland.page ) {
        this.modelIslandRaw = view.modelIslandAt(modelPoint);
        this.docIslandRaw   = docIslandRaw;
      }
    }

    this.modelPointRaw = modelPoint;
    this.docPointRaw = view.modelToDoc(modelPoint,this.docIslandRaw);

    return this.trackData();
  },

  trackData() {
    return {
      modelIsland    : this.modelIsland,
      docIsland      : this.docIsland,
      docPoint       : this.docPoint,
      modelPointRaw  : this.modelPointRaw,
      modelIslandRaw : this.modelIslandRaw,
      docIslandRaw   : this.docIslandRaw,
      docPointRaw    : this.docPointRaw,
    };
  },

  move(event) {
    this.event = event;
    return this.retargetedEvent;
  }
};


function interpolatingExtension( newFrom, firstFrom, lastFrom, firstTo, lastTo ) {

  if( firstFrom.isEqual( lastFrom ) ) {
    return lastTo.clone();
  }

  const
  last_firstFrom = lastFrom .minus( firstFrom ),
  last_firstFrom_norm = last_firstFrom.norm(),
  last_firstFrom_n = last_firstFrom.scaled( 1 / last_firstFrom_norm ),
  new_firstFrom = newFrom .minus( firstFrom ),

  dotProductFrom = Point.dotProduct( last_firstFrom, new_firstFrom ),

  ap = last_firstFrom_n.scaled( dotProductFrom / last_firstFrom_norm ),
  alpha = ap.norm() / last_firstFrom_norm * ( dotProductFrom >= 0 ? 1 : -1 ),

  bp = new_firstFrom.minus( ap ),
  beta = ( bp.norm() / last_firstFrom_norm ) *
         ( Point.dotProduct( bp, last_firstFrom.perpendicular(-1) ) >= 0 ? -1 : 1 ),

  last_firstTo = lastTo .minus( firstTo ),
  adp = last_firstTo.scaled(alpha),
  bdp = last_firstTo.perpendicular(-1).scaled(beta);

  return firstTo .plus(adp) .plus(bdp);
}



/** WEBPACK FOOTER **
 ** ./src/ui/canvas3d/move3d.js
 **/